import { MenuItem, Select } from "@mui/material";
import React from "react";
import { ZeroBaseFeeSettingsContext } from "./ZeroBaseFeeSettings";


type ZeroOptions = "zeroBaseFee" | 'non-zeroBaseFee' | 'all';


export const ZeroBaseFeeDropdown = () => {
  const settings = React.useContext(ZeroBaseFeeSettingsContext);
  const [dropdownValue, setDropdownValue] = React.useState<ZeroOptions>('zeroBaseFee');

  function handleChange(e) {
    const newVal = e.target.value;
    setDropdownValue(newVal);

    if (newVal === 'all') {
      settings.setEnabled(true, true);
    } else if (newVal === 'zeroBaseFee') {
      settings.setEnabled(true, false);
    } else if (newVal === 'non-zeroBaseFee') {
      settings.setEnabled(false, true);
    }
  }

  return (
    <div>
      <div className="flex justify-center pt-24 pb-8">
        <div>
          <p className="text-lg text-gray-500 font-bold">Display graph with</p>
          <Select
            value={dropdownValue}
            onChange={handleChange}
            variant="outlined"
            style={{minWidth: '400px'}}
          >
            <MenuItem value='zeroBaseFee'>zeroBaseFee channels only</MenuItem>
            <MenuItem value='non-zeroBaseFee'>non-zeroBaseFee channels only 📵 <span className="text-gray-500 pl-1 text-xs">
              (not mobile friendly)
              </span></MenuItem>
            <MenuItem value='all'>all channels 📵 <span className="text-gray-500 pl-1 text-xs">
              (not mobile friendly)</span></MenuItem>
          </Select>
        </div>
      </div>

      <div className="flex flex-col-reverse md:flex-row flex-wrap justify-between md:items-end px-2">
        <div className="text-sm text-gray-600 flex flex-wrap">
          <div className="pr-2"><span className="inline-block px-1 py-1" style={{ background: '#4cfaf8' }}></span> zeroBaseFee</div>
          <div><span className="inline-block px-1 py-1" style={{ background: '#daa058' }}></span> non-zeroBaseFee</div>
        </div>

      </div>
    </div>
  );
};
